// Centralized test IDs for the CertifyAI platform.
export * from './auth';
export * from './home';

export const LANDING = {
    heroCTA: 'landing-hero-cta',
    loginNav: 'landing-login-nav',
    registerNav: 'landing-register-nav',
};

export const AUTH = {
    emailInput: 'auth-email-input',
    passwordInput: 'auth-password-input',
    nameInput: 'auth-name-input',
    companyInput: 'auth-company-input',
    submitButton: 'auth-submit-button',
    toggleRegister: 'auth-toggle-register',
    toggleLogin: 'auth-toggle-login',
    logoutButton: 'logout-button',
};

export const CLIENT = {
    dashboard: 'client-dashboard',
    newRequestButton: 'client-new-request-button',
    standardSelect: 'client-standard-select',
    industryInput: 'client-industry-input',
    notesInput: 'client-notes-input',
    submitRequest: 'client-submit-request',
    requestRow: 'client-request-row',
    downloadReport: 'client-download-report',
};

export const INSPECTOR = {
    dashboard: 'inspector-dashboard',
    inspectionRow: 'inspector-inspection-row',
    openChecklist: 'inspector-open-checklist',
    answerYes: 'inspector-answer-yes',
    answerNo: 'inspector-answer-no',
    answerNA: 'inspector-answer-na',
    observationsInput: 'inspector-observations-input',
    uploadEvidence: 'inspector-upload-evidence',
    submitChecklist: 'inspector-submit-checklist',
    scoreDisplay: 'inspector-score-display',
};

export const ADMIN = {
    dashboard: 'admin-dashboard',
    usersTab: 'admin-users-tab',
    standardsTab: 'admin-standards-tab',
    requestsTab: 'admin-requests-tab',
    createUserButton: 'admin-create-user-button',
    createStandardButton: 'admin-create-standard-button',
    uploadDocButton: 'admin-upload-doc-button',
    generateChecklistButton: 'admin-generate-checklist-button',
    assignInspectorSelect: 'admin-assign-inspector-select',
    assignInspectorButton: 'admin-assign-inspector-button',
    approveButton: 'admin-approve-button',
    rejectButton: 'admin-reject-button',
    decisionComment: 'admin-decision-comment',
};
